export const toast = function () {
  let toastElList = [].slice.call(document.querySelectorAll('.toast'));
  let toastList = toastElList.map(function (toastEl) {
    return new bootstrap.Toast(toastEl, { 'animation' : true, 'delay': 5000 }).show();
  })
}